import React from "react";
import { motion } from "framer-motion";

const AboutUsBody1 = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className="max-w-7xl mx-auto py-20 px-6 bg-gray-100 text-center rounded-xl shadow-md"
    >
      <h2 className="text-4xl font-bold text-[#29313F]  mb-6 tracking-wide">
        Building Excellence, Shaping the Future
      </h2>
      <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
        At <span className="font-semibold text-[#29313F] ">Petriek Structures</span>, we are dedicated to delivering 
        high-quality, sustainable, and innovative construction solutions. Our expert team specializes in 
        residential, commercial, and infrastructure projects, ensuring durability, efficiency, and architectural excellence.
      </p>
    </motion.section>
  );
};

export default AboutUsBody1;
